import { DateTime } from 'luxon';

export const getStartDate = (timeZone: string, initialTime?: string): DateTime => {
  const now = DateTime.now().setZone(timeZone);
  const { hours, minutes } = parseInitialTime(initialTime);

  let startDate = now.set({
    hour: hours,
    minute: minutes,
    second: 0,
    millisecond: 0,
  });

  // If current time is past initialTime, move to next day
  if (now.hour > hours || (now.hour === hours && now.minute > minutes)) {
    // Use console.warn instead of console.debug to comply with linting rules
    console.warn('Current time is past initial start time - moving to next day');
    startDate = startDate.plus({ days: 1 });
  }

  return startDate;
};

export const getEndDate = (startDate: DateTime, initialTime?: string): DateTime => {
  const { hours, minutes } = parseInitialTime(initialTime);

  const endDate = startDate.plus({ days: 1 }).set({
    hour: hours,
    minute: minutes,
    second: 0,
    millisecond: 0,
  });

  return endDate;
};

const parseInitialTime = (timeString?: string) => {
  if (!timeString) {
    return { hours: 0, minutes: 0 };
  }

  const parts = timeString.split(':');
  if (parts.length !== 2 || isNaN(Number(parts[0])) || isNaN(Number(parts[1]))) {
    console.warn(`Invalid time format: ${timeString}. Expected format is 'HH:MM'`);
    return { hours: 0, minutes: 0 };
  }

  const hours = Number(parts[0]);
  const minutes = Number(parts[1]);

  return { hours, minutes };
};

/**
 * Converts MM:SS format to seconds (float)
 */
export const timeToSeconds = (timeStr: string): number => {
  if (!timeStr) return 0;
  const parts = timeStr.split(':');
  if (parts.length !== 2) return 0;
  const [minutes, seconds] = parts.map(Number);
  if (isNaN(minutes) || isNaN(seconds)) return 0;
  return minutes * 60 + seconds;
};

/**
 * Converts seconds (float) to MM:SS format
 */
export const secondsToTime = (seconds: number): string => {
  if (seconds === 0) return '00:00';
  if (!seconds || isNaN(seconds)) return '00:00';
  const mins = Math.floor(seconds / 60);
  const secs = Math.round(seconds % 60);

  // Handle overflow when seconds round to 60
  if (secs === 60) {
    return `${(mins + 1).toString().padStart(2, '0')}:00`;
  }

  return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
};
